export const ui = {
    homeHero: document.querySelector('.bloc-top-page') as HTMLElement,
    homeTestimony: document.querySelector('.section-testimony-mobile') as HTMLElement,
    testimonyList: document.querySelector('.agency-slider') as HTMLElement,
    otherTestimony: document.querySelector('.otherTestimony-slider') as HTMLElement,
    gallery: {
        large: document.querySelector('.gallerySlider__large') as HTMLElement,
        small: document.querySelector('.gallerySlider__small__wrapper') as HTMLElement,
    },
    gifts: document.querySelector('.swiper.slider-gifts') as HTMLElement,
    avis: document.querySelector('.avis-slider') as HTMLElement,
}
